<template>
  <section>
    <el-table
      :data="tableData"
      class="el-table-info"
      stripe
      style="margin-left: 5%;width: 90%;"
    >
      <el-table-column
        :formatter="publicFmt"
        prop="shipName"
        label="船舶名称"
        width="80">
      </el-table-column>
      <el-table-column
        :formatter="publicFmt"
        prop="epartureTimeDate"
        label="离港日期"
        width="80">
      </el-table-column>
      <el-table-column
        :formatter="costTypeFmt"
        prop="costTypeName"
        label="费用类型"
        width="80">
      </el-table-column>
      <el-table-column
        :formatter="publicFmt"
        prop="contractCompanyName"
        label="收票公司"
        width="100">
      </el-table-column>
      <el-table-column
        :formatter="publicFmt"
        prop="billTax"
        label="税率"
        width="90">
      </el-table-column>
      <el-table-column
        :formatter="NumFmt"
        prop="arrearsAmount"
        label="欠票金额"
        width="100"
      >
      </el-table-column>
      <el-table-column
        :formatter="NumFmt"
        prop="leftOver"
        label="剩余总进票"
        width="150"
      >
      </el-table-column>
      <el-table-column
        :formatter="NumFmt"
        prop="currentAmount"
        label="本次进票金额"
      >
      </el-table-column>
    </el-table>
    <div style="display:flex;width: 90%;margin: 10px 0;margin-left: 5%;">
      <div class="sp_add_left" style="display:flex;">
        <div style="width: 40%;line-height: 40px;">进票总金额:</div>
        <div style="width: 60%">
          <el-input v-model="applicationForm.totalPayment"  clearable disabled>
            <template slot="append">元</template>
          </el-input>
        </div>
      </div>
      <div class="sp_add_right" style="display:flex;">
        <div style="width: 40%;line-height: 40px;">开票公司:</div>
        <div style="width: 60%;line-height: 40px;text-align: left;">
          {{applicationForm.sysSupplierFullName}}
        </div>
      </div>
    </div>
    <div style="display:flex;width: 90%;margin: 10px 0;margin-left: 5%;">
      <div class="sp_add_left" style="display:flex;">
        <div style="width: 40%;line-height: 40px;">进票金额:</div>
        <div style="width: 60%">
          <el-input v-model="applicationForm.ticketPayment" placeholder="请选择结算航次"  clearable disabled>
            <template slot="append">元</template>
          </el-input>
        </div>
      </div>
      <div class="sp_add_right" style="display:flex;">
        <div style="width: 40%;line-height: 40px;">发票号:</div>
        <div style="width: 60%">
          <el-input v-model="applicationForm.invoiceNumber" placeholder="无票号" clearable disabled>
          </el-input>
        </div>
      </div>
    </div>
    <div style="display:flex;width: 90%;margin: 10px 0;margin-left: 5%;">
      <div class="sp_add_left" style="display:flex;">
        <div style="width: 40%;line-height: 40px;">核销到历史付款金额:</div>
        <div style="width: 60%">
          <el-input v-model="applicationForm.additionalPrice"  clearable disabled>
            <template slot="append">元</template>
          </el-input>
        </div>
      </div>
      <div class="sp_add_right" style="display:flex;">
        <div style="width: 40%;line-height: 40px;">核销历史付款备注:</div>
        <div style="width: 60%">
          <el-input v-model="applicationForm.additionalRemark" placeholder="无备注" clearable disabled></el-input>
        </div>
      </div>
    </div>
      <div style="display:flex;width: 90%;margin: 10px 0;margin-left: 5%;" v-show="applicationForm.price">
          <div class="sp_add_left" style="display:flex;">
            <div style="width: 40%;line-height: 40px;">预付款账户余额:</div>
            <div style="width: 60%">
              <el-input v-model="applicationForm.advanceBalance" disabled placeholder="无预付款账户"  clearable>
                <template slot="append">元</template>
              </el-input>
            </div>
          </div>
          <div class="sp_add_right" style="display:flex;">
            <div style="width: 40%;line-height: 40px;">预付款抵扣:</div>
            <div style="width: 60%">
              <el-input v-model="applicationForm.price" disabled placeholder="" clearable></el-input>
            </div>
          </div>
        </div>
  </section>
</template>

<script>
    import {fmtDictionary} from "../../jslib/util";
    import dayjs from "dayjs";
    import {getDictionaryList} from "../../api/sysdictionary";
    import {ERR_OK} from "../../jslib/config";
    import {getPayment} from "../../api/PaymentApply";
import currency from 'currency.js';

    export default {
        name: "TicketApprove",
      props: {
        datas: {
          type: Object
        },
        applyObj:{
          type: Object
        },
      },
      data(){
        return{
          tableData:[],
          dictionaryLists:[],
          applicationForm:{},
        }
      },
      mounted() {
        this.getData()
        getDictionaryList("cost_type").then(res=>{
          if (res!=undefined&&res.resultCode === ERR_OK) {
            this.dictionaryLists = res.map
          }
        })
      },
        methods: {
          getData(params1){
            this.tableData = []
            this.applicationForm = {}
            console.info(this.applyObj)
            if(this.applyObj){
              this.tableData = this.applyObj.applylist
              this.applicationForm = this.applyObj.application
              if(this.applicationForm.ticketPayment){
                this.applicationForm.ticketPayment = currency(this.applicationForm.ticketPayment, { precision: 2 }).value
              }
            } else {
              if (!params1 && (!this.datas || !this.datas.params1)) {
                return
              }
              var querydata = {
                paymentId: params1 ? params1 : this.datas.params1,
                type:1
              }
              getPayment(querydata).then(res =>{
                if (res!=undefined&&res.resultCode === ERR_OK) {
                  this.applicationForm = res.obj
                  this.tableData = res.list
                  this.applicationForm.ticketPayment = currency(this.applicationForm.ticketPayment, { precision: 2 }).value
                  // this.applicationForm.totalPayment = Number(this.applicationForm.ticketPayment)+Number(this.applicationForm.additionalPrice)
                  // 保留2位小数
                  this.applicationForm.totalPayment = currency(this.applicationForm.ticketPayment, { precision: 2 }).add(currency(this.applicationForm.additionalPrice, { precision: 2 })).value
                }
              })
            }
          },
          costTypeFmt(row,column,cellValue,index){
            return fmtDictionary(cellValue,this.dictionaryLists['cost_type']);
          },
          myFmtDateTime(cellValue,fmtstr){
            if(cellValue==undefined||cellValue==null||cellValue==''){
              return '--'
            }
            return dayjs(cellValue).format(fmtstr)
          },
          publicFmt(row,column,cellValue,index){
            var v = '--'
            if(cellValue!=undefined&&cellValue!=null&&cellValue!=''){
              v = cellValue
            }
            return v
          },
          NumFmt(row,column,cellValue,index){
            var v = 0
            if(cellValue!=undefined&&cellValue!=null&&cellValue!=''){
              v = parseFloat(Math.abs(cellValue).toFixed(2)) && parseFloat(Math.abs(cellValue).toFixed(2)).toString().replace(/(^|\s)\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
            }
            return v
          },
          number_format(num) {
            var v = 0
            if(!!num){
              v = parseFloat(Math.abs(num).toFixed(2)) && parseFloat(Math.abs(num).toFixed(2)).toString().replace(/(^|\s)\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
            }
            return v
          },
        }
    }
</script>

<style scoped>
  .query-form{
    text-align: left;
    padding-top: 10px;
  }
  .sp_add_left{
    width: 45%;
    margin-right: 5%;
  }
  .sp_add_right{
    width: 45%;
  }
  .el-table-info >>> .cell{
    text-align: center;
  }
  .el-table-info >>> th {
    background: #EDF5FF;
  }
</style>
